const Privacy = () => {
  return (
    <div data-testid="privacy-page">
      <section className="page-header">
        <div className="page-container">
          <h1 className="page-title">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="page-container">
          <div className="max-w-3xl">
            <h2 className="text-xl font-heading mt-8 mb-4">Collecte des données</h2>
            <p className="text-muted-foreground mb-4">
              Les données personnelles collectées sur ce site (nom, email, téléphone) sont 
              uniquement utilisées pour :
            </p>
            <ul className="list-disc list-inside text-muted-foreground mb-4 space-y-2">
              <li>Répondre à vos demandes de projets</li>
              <li>Gérer vos rendez-vous et réservations de flashs</li>
              <li>Traiter vos commandes sur la boutique</li>
              <li>Répondre à vos messages via le formulaire de contact</li>
            </ul>

            <h2 className="text-xl font-heading mt-8 mb-4">Conservation des données</h2>
            <p className="text-muted-foreground mb-4">
              Vos données personnelles sont conservées pendant la durée nécessaire au traitement 
              de votre demande, puis archivées conformément aux obligations légales (notamment 
              comptables pour les transactions).
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Partage des données</h2>
            <p className="text-muted-foreground mb-4">
              Vos données ne sont jamais vendues ni partagées avec des tiers à des fins commerciales.
              Seuls les prestataires techniques nécessaires au fonctionnement du site (hébergement, 
              paiement) peuvent y avoir accès dans le cadre strict de leurs prestations.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Paiement sécurisé</h2>
            <p className="text-muted-foreground mb-4">
              Les paiements sont gérés par Stripe. Je n'ai pas accès à vos données bancaires 
              qui sont directement traitées par ce prestataire de paiement certifié PCI-DSS.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Vos droits</h2>
            <p className="text-muted-foreground mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside text-muted-foreground mb-4 space-y-2">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition</li>
            </ul>
            <p className="text-muted-foreground mb-4">
              Pour exercer ces droits, contactez-moi via le formulaire de contact ou par Instagram.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Cookies</h2>
            <p className="text-muted-foreground mb-4">
              Ce site utilise uniquement des cookies techniques essentiels au bon fonctionnement 
              (gestion du panier, préférences). Aucun cookie publicitaire ou de suivi n'est utilisé.
            </p>

            <h2 className="text-xl font-heading mt-8 mb-4">Contact</h2>
            <p className="text-muted-foreground mb-4">
              Pour toute question concernant cette politique de confidentialité, vous pouvez 
              me contacter via le formulaire de contact du site ou par Instagram (@nymphea.ttt).
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
